import { EVENTS_LOG_ERROR_TYPE } from "const/eventsLog";

import { getValueByPath } from "utils/getValueByPath";

export const getEventMessageText = (event, templates, fieldMap) => {
  const eventKey = event?.payload?.translationKey;
  let template = templates[eventKey];

  if (event.deviceType === "nc" &&
    (eventKey === "sw_port_error_recover" || eventKey === "router_port_error_recover") &&
    getValueByPath(event, "payload.errorType") === null) {
    template = template?.replace(". Error: <ErrorTypeString>", ".");
  }

  const mapRule = fieldMap[eventKey] || {};

  if (!template) return "-";

  const formattedData = template.split(/(<[^<>]+>|{[^{}]+})/g);

  const renderValue = (v, depth = 1) => {
    const indent = "    ".repeat(depth);
    if (v === null || v === undefined) return "";
    if (Array.isArray(v)) return v.join(", ");
    if (typeof v === "object") {
      return Object.entries(v)
        .map(([nk, nv]) => `\n${indent}${nk}: ${renderValue(nv, depth + 1)}`)
        .join("");
    }
    return String(v);
  };

  const renderObjectValue = (obj) => {
    return Object.entries(obj)
      .map(([k, v]) => {
        const isValObject = typeof v === "object" && v !== null && !Array.isArray(v);
        return `${k}: ${isValObject ? "" : ""}${renderValue(v)}`;
      })
      .join("\n");
  };

  const result = formattedData.map((item) => {
    const match = item.match(/^<(.+)>$|^{(.+)}$/);
    if (!match) return item;

    const key = match[1] || match[2];
    let path = mapRule[key];
    // translationKey 有 ap_client 的字串 (ClientNameWithMACAsLink)
    // 必須顯示 clientName
    // 如果 clientName 是 null 或空字串就用 macAddress 
    if (eventKey.includes("ap_client") && key === "ClientNameWithMACAsLink") {
      const clientName = getValueByPath(event, "payload.clientName");
      path = clientName ? "payload.clientName" : "payload.macAddress";
    }
    // 有值需要前端特別做轉換使用 translationValue
    let translationValue
    if (((eventKey.includes("sw_port_error") || eventKey.includes("router_port_error")) && key === "ErrorTypeString")
      || ((eventKey.includes("sw_port_error_recover") || eventKey.includes("router_port_error_recover")) && key === "ErrorTypeString")) {
      const errorTypeValue = getValueByPath(event, "payload.errorType");
      translationValue = EVENTS_LOG_ERROR_TYPE[errorTypeValue]
    }

    const value = translationValue
      ? translationValue
      : path
        ? getValueByPath(event, path)
        : undefined;

    if (value === undefined) return item;

    return typeof value === "object" && value !== null
      ? renderObjectValue(value)
      : value === null || value === undefined ? "" : String(value);
  });

  return result.join("");
};
